/* FONTS */
const customFonts = [{name: 'Futura Bold'}, 
                     {name: 'Impact'},
                     {name: 'BlackListed'},
                     {name: 'Android Assassin'},
                     {name: 'Gotham Black Regular'},
                     {name: 'Heroes Legend'},
                     {name: 'Heroes Legend Hollow'},
                     {name: 'Overpass'},
                     {name: 'TungstenNarrow'}];

export default {
    FONTS: customFonts
}
